/* eslint-disable */

export const createScheduledOrder = {
    FETCH_CREATE_SCHEDULED_ORDER_REQUEST: 'FETCH_CREATE_SCHEDULED_ORDER_REQUEST',
    FETCH_CREATE_SCHEDULED_ORDER_SUCCESS: 'FETCH_CREATE_SCHEDULED_ORDER_SUCCESS',
    FETCH_CREATE_SCHEDULED_ORDER_FAILURE: 'FETCH_CREATE_SCHEDULED_ORDER_FAILURE',
};
